import InternetImg from "public/network-services/icons/internet-dci.png";
import SocImg from "public/network-services/icons/noc-soc-helpdesk.png";
import MonitoringImg from "public/network-services/monitoring.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: InternetImg,
    title: "Optimized Connectivity",
    text: "Ensure ultra-fast, low-latency data transfer across clouds, data centers, and enterprise networks.",
  },
  {
    image: SocImg,
    title: "Zero Compromise",
    text: "Achieve carrier-neutral reliability without sacrificing speed, security, or performance.",
  },
  {
    image: MonitoringImg,
    title: "Fully Managed",
    text: "Enjoy seamless operations with end-to-end monitoring, support, and proactive optimization.",
  },
];
